import {
  deleteRequest,
  deleteRequestWithData,
  getRequest,
  postRequest,
  putRequest,
} from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";

//-------Get Product Types
const getCustomProductTypes = (storeId, companyId) => {
  return getRequest(`product-types/${storeId}/${companyId}`).then(
    //(response) => response?.data?.data,
    (response) => {
      const data = response?.data?.data || [];
      // Filter out items where productType === "Trading Card"
      return {
        ...data,
        productTypes: data.productTypes.filter(
          (item) => item.productType !== "Trading Card"
        ),
      };
    },
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Custom Categories
const getCustomCategories = (storeId, companyId) => {
  return getRequest(`category/${storeId}/${companyId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Custom Sub Categories
const getCustomSubCategories = (storeId, companyId) => {
  return getRequest(`subcategory/${storeId}/${companyId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Add Product Types
const addCustomProductType = (storeId, data, companyId) => {
  return postRequest(`product-types/${storeId}/${companyId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Add Custom Categories
const addCustomCategory = (storeId, data, companyId) => {
  return postRequest(`category/${storeId}/${companyId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Add Custom Sub Categories
const addCustomSubCategory = (storeId, data, companyId) => {
  return postRequest(`subcategory/${storeId}/${companyId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Delete Product Types
const deleteCustomProductType = (storeId, data, companyId) => {
  return deleteRequestWithData(
    `product-types/${storeId}/${companyId}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Delete Custom Categories
const deleteCustomCategory = (storeId, categoryId, companyId) => {
  return deleteRequest(`category/${storeId}/${companyId}/${categoryId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Delete Custom Sub Categories
const deleteCustomSubCategory = (storeId, data, companyId) => {
  return deleteRequestWithData(
    `subcategory/${storeId}/${companyId}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Update Product Types
const updateCustomProductType = (storeId, data, companyId) => {
  return putRequest(`product-types/${storeId}/${companyId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Update Custom Categories
const updateCustomCategory = (storeId, categoryId, data, companyId) => {
  return putRequest(
    `category/${storeId}/${companyId}/${categoryId}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Update Custom Sub Categories
const updateCustomSubCategory = (storeId, data, companyId) => {
  return putRequest(`subcategory/${storeId}/${companyId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Export inventory Services
export const ItemOrganizationService = {
  addCustomCategory,
  getCustomCategories,
  addCustomSubCategory,
  deleteCustomCategory,
  updateCustomCategory,
  addCustomProductType,
  getCustomProductTypes,
  getCustomSubCategories,
  deleteCustomProductType,
  deleteCustomSubCategory,
  updateCustomProductType,
  updateCustomSubCategory,
};
